import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Truck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../api";

export default function RegisterPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      toast.success("Akun dibuat dengan role Kasir/Keuangan. Hubungi Owner untuk akses lebih.");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100 p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-md bg-emerald-700 flex items-center justify-center">
            <Truck className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-zinc-900">Trip Surat Jalan</h1>
            <p className="text-xs text-zinc-500">Registrasi Akun</p>
          </div>
        </div>
        <h2 className="text-2xl font-semibold tracking-tight text-zinc-900 mb-1">Daftar</h2>
        <p className="text-sm text-zinc-500 mb-6">Akun baru mendapat role <b>Kasir/Keuangan</b>. Owner akan menentukan role Anda selanjutnya.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="name">Nama</Label>
            <Input id="name" data-testid="register-name-input" required value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nama lengkap" className="bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="register-email-input" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="email@trip.co.id" className="bg-white" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="register-password-input" type="password" required minLength={6} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Min. 6 karakter" className="bg-white" />
          </div>
          {error && (
            <p data-testid="register-error-message" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</p>
          )}
          <Button data-testid="register-submit-button" type="submit" disabled={loading}
            className="w-full bg-emerald-700 hover:bg-emerald-800 text-white transition-colors duration-200">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Daftar
          </Button>
        </form>
        <p className="text-sm text-zinc-500 mt-6">
          Sudah punya akun?{" "}
          <Link data-testid="login-link" to="/login" className="text-emerald-700 font-medium hover:underline">Masuk</Link>
        </p>
      </div>
    </div>
  );
}
